import { Position, Toaster, Intent } from "@blueprintjs/core";
const ErrorNotification = Toaster.create({
	position: Position.TOP,
	intent: Intent.DANGER,
	timeout: 5000
});

export default ErrorNotification;



// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/ErrorNotification.js